import * as z from "zod/v4";

export const getToteByFulfillmentGroupId = {
  name: "getToteByFulfillmentGroupId" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
  }),
  output: z.object({
    toteId: z.string().nullable(),
    toteBarcode: z.string().nullable(),
  }),
};
